import React from 'react';
import { UIHeading2 } from '@cian/ui-kit';
import { plural } from '@cian/utils';

import { numberWithDelimiter } from '../../utils';
import { SortButton, ESortButtonValue } from './components/SortButton';
import { PostCommentsNotifySwitcher } from '../PostCommentsNotifySwitcher';
import * as s from './PostCommentsHeader.css';

export interface IPostCommentsHeader {
  commentsCount: number;
}

/**
 * Шапка листинга комментариев
 */
export const PostCommentsHeader = ({ commentsCount }: IPostCommentsHeader) => {
  const preparedCommentsCount = numberWithDelimiter(commentsCount);

  return (
    <div className={s['wrapper']}>
      <UIHeading2>
        {preparedCommentsCount} {plural(commentsCount, ['комментарий', 'комментария', 'комментариев'])}
      </UIHeading2>

      <SortButton onClick={() => {}} value={ESortButtonValue.Popular} />
      <PostCommentsNotifySwitcher onChange={() => {}} />
    </div>
  );
};
